<template>
  <div class="user-list-widget">
    <EmptyState v-if="showEmptyState" :data="emptyStateData" />

    <v-list v-else color="transparent" class="pt-0">
      <v-list-item
        v-for="user in users"
        class="px-0"
        data-testid="user-list-item"
        :key="user.title"
      >
        <UserAvatar
          data-testid="user-list-avatar"
          size="32px"
          fontSize="10px"
          class="me-2"
          :account="user"
        />

        <v-list-item-content>
          <router-link
            class="text-decoration-none"
            :to="`/profile/${userOrganizationId}/${user.userId}`"
          >
            <v-list-item-title
              data-private
              class="user-list-widget__user-name"
              data-testid="user-list-name"
              v-html="sanitizeContent(user.name)"
            ></v-list-item-title>
          </router-link>
        </v-list-item-content>
        <v-chip
          data-private
          v-if="user.details"
          outlined
          data-testid="user-list-details"
          v-html="sanitizeContent(user.details)"
        ></v-chip>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import EmptyState from '@/containers/ReportsView/Widgets/EmptyState.vue'
import mixin from '@/mixins/mixin.vue'
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'UserList',

  mixins: [mixin],

  components: {
    EmptyState,
    UserAvatar,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['organizationId']),

    users() {
      return this.data?.users ?? []
    },

    showEmptyState() {
      return _.isEmpty(this.users)
    },

    emptyStateData() {
      return {
        action: {},
        content: this.$t('insights.no_results_for_your_filters'),
        title: this.$t('insights.no_data'),
      }
    },

    userOrganizationId() {
      const routeQueryOrganization = this.getRouteQuery()?.organization ?? null
      return routeQueryOrganization ?? this.organizationId
    },
  },

  methods: {
    sanitizeContent(content) {
      return this.$sanitize(content)
    },
  },
}
</script>

<style lang="scss" scoped>
.user-list-widget {
  max-width: 90%;

  &__user-name {
    color: $color-blue-grey-darken3;

    &:hover {
      color: $color-blue;
    }
  }
}
</style>
